import root from 'window-or-global';

export const HANDLE_TOGGLE_OPEN_STATE = 'HANDLE_TOGGLE_OPEN_STATE';
export function handleToggleOpenState (tab, isOpen) {
  return {
    type: HANDLE_TOGGLE_OPEN_STATE,
    payload: {
      tab, isOpen,
    },
  };
}

export const HANDLE_TOGGLE_PAYMENT_POPUP = 'HANDLE_TOGGLE_PAYMENT_POPUP';
export const HANDLE_TOGGLE_INITIALIZE_FORM_ANIMATED = 'HANDLE_TOGGLE_INITIALIZE_FORM_ANIMATED';
export function handleTogglePaymentPopup () {
  return (dispatch, getState) => {
    dispatch ({
      type: HANDLE_TOGGLE_PAYMENT_POPUP,
    });

    if (getState().settings.isMobileDevice) {
      // touch devices do not have the modal animation
      return;
    }

    setTimeout(() => {
      dispatch({
        type: HANDLE_TOGGLE_INITIALIZE_FORM_ANIMATED,
      });
    }, 400 /* approx time the toggle payment popup animation will last */);
  };
}

export function setOfferPagePaymentButtonClickListener () {
  return dispatch => {
    root.isPaymentsPopupReady = true;
    const intr = setInterval(() => {
      if (root.isPaymentButtonClicked) {
        dispatch(handleTogglePaymentPopup());
        clearInterval(intr);
      }
    }, 100);
  };
}

export const SHOW_DEFERRED_MERCHANT_HEADER = 'SHOW_DEFERRED_MERCHANT_HEADER';
export const showDeferredMerchantHeader = () => ({
  type: SHOW_DEFERRED_MERCHANT_HEADER,
});

export const HANDLE_AWAITING_PAYMENT_COMPLETION = 'HANDLE_AWAITING_PAYMENT_COMPLETION';
export const handleAwaitingPaymentCompletion = (waitingStatus = true) => ({
  type: HANDLE_AWAITING_PAYMENT_COMPLETION,
  waitingStatus,
});



// WEBPACK FOOTER //
// ./src/payments/actions/SettingsActions.js